<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading"
    class="flex flex-row items-center gap-6 font-semibold text-[#424242] dark:text-white mb-4 mr-5 ml-0 cursor-pointer">
    <p (click)="onCancel()">Manage Officers</p>
    <p>Add Officer</p>
</div>

<div #scrollTarget *ngIf="!isLoading" class="mx-auto p-6 bg-white dark:bg-[#363636] rounded-lg shadow-mg">
    <form #PageOneForm="ngForm" (ngSubmit)="onSubmitForm1(PageOneForm)">

        <div *ngIf="selectedPage === 'pageOne'">
            <h2 class="text-xl mb-6 text-[#292929] dark:text-textDark font-semibold">Add Personal Details</h2>
            <div>
                <div class="flex justify-center pt-3 mb-12">
                    <div class="relative">
                        <input type="file" id="imageUpload" accept="image/*" class="hidden"
                            (change)="onFileSelected($event)" />

                        <!-- Display default image if no file is selected -->
                        <div *ngIf="!selectedImage" (click)="triggerFileInput($event)"
                            class="flex rounded-full border-solid border-2 justify-center items-center  w-40 h-40 bg-gray-100">
                            <i class="fa-regular fa-user text-8xl text-gray-400"></i>
                        </div>



                        <!-- Display the selected image if available -->
                        <img *ngIf="selectedImage" class="rounded-full w-40 h-40 object-cover" [src]="selectedImage"
                            alt="Profile Picture" />


                        <span (click)="triggerFileInput($event)"
                            class="absolute bottom-5 right-5 transform translate-x-1/4 translate-y-1/4 px-3 py-2  bg-[#3980C0] rounded-full cursor-pointer">
                            <i class="fa-solid fa-pen text-xl text-white"></i>
                        </span>
                    </div>
                </div>
                <!-- <div class="flex justify-center pt-3 pb-9">
                    <p *ngIf="!selectedImage" class="text-red-500 text-sm mt-2">Profile image is required.</p>
                </div> -->


                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">


                    <div *ngIf="logingRole === 'Collection Centre Head'">
                        <label for="centerId" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                            Collection Centre Name *
                        </label>

                        <!-- Dropdown container -->
                        <div class="relative w-full">
                            <!-- Input acting as dropdown -->
                            <div class="relative">
                                <input type="text" id="centerId" name="centerId" [(ngModel)]="selectedCenterName"
                                    #centerIdInput="ngModel" required placeholder="-- Select a centre --" readonly
                                    (click)="toggleDropdown()"
                                    class="form-control focus:outline-none focus:ring-0 focus:border-gray-300 mt-1 block w-full p-2 pr-10 border border-gray-300 rounded-md bg-[#ffffff] dark:bg-[#1D1D1F] dark:text-textDark cursor-pointer" />

                                <!-- Arrow icon -->
                                <i *ngIf="!centreDropdownOpen"
                                    class="fa-solid fa-angle-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>

                                <i *ngIf="centreDropdownOpen"
                                    class="fa-solid fa-angle-up absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                            </div>

                            <!-- Dropdown panel -->
                            <div *ngIf="centreDropdownOpen"
                                class="absolute z-50 mt-1 w-full bg-white border dark:bg-[#292929] dark:text-textDark border-gray-200 dark:border-[#828282] rounded-md max-h-60 overflow-y-auto shadow-lg">

                                <!-- Sticky search input -->
                                <div class="sticky top-0 bg-gray-100 dark:bg-[#292929] z-20">
                                    <div class="relative">
                                        <input type="text" placeholder="Search..." (input)="onSearchInput($event)"
                                            class="dropdown-search-input form-control  dark:text-textDark dark:bg-[#292929] w-full p-2 pr-10 border-b border-gray-300 rounded-t-md" />
                                        <i
                                            class="fa-solid fa-magnifying-glass absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"></i>
                                    </div>
                                </div>

                                <!-- List -->
                                <div *ngFor="let item of filteredCenterArr"
                                    class="flex items-center p-2 hover:bg-gray-200 dark:hover:bg-gray-700 dark:text-textDark cursor-pointer"
                                    (click)="selectCenter(item)">
                                    <span [ngClass]="{
          'text-blue-600 dark:text-blue-400 font-medium': item.id === personalData.centerId,
          'text-gray-900 dark:text-textDark': item.id !== personalData.centerId
        }">

                                        {{ item.regCode }} - {{ item.centerName }}

                                    </span>
                                    <span *ngIf="item.id === personalData.centerId" class="ml-2 text-blue-600">✓</span>
                                </div>
                                <div *ngIf="filteredCenterArr.length === 0"
                                    class="p-2 text-gray-500 dark:text-gray-400 bg-white dark:bg-[#292929] text-sm text-center">
                                    No options found
                                </div>
                            </div>
                        </div>


                        <!-- Validation -->
                        <div *ngIf="centerIdInput.touched && !personalData.centerId" class="text-red-500 text-sm mt-2">
                            Collection Centre Name is required
                        </div>
                    </div>

                    <div *ngIf="logingRole === 'Collection Centre Head'"></div>


                    <div class="relative" (clickOutside)="isJobRoleOpen = false">
                        <label for="jobRole" class="block text-sm font-medium text-[#534E4E] mb-1 dark:text-textDark">
                            Job Role *
                        </label>

                        <!-- Dropdown button -->
                        <div class="relative">
                            <input type="text" id="jobRole" name="jobRole" [(ngModel)]="personalData.jobRole"
                                placeholder="-- Select a job role --" readonly (click)="toggleJobRoleDropdown()"
                                class="form-control focus:outline-none focus:ring-0 focus:border-gray-300 mt-1 block w-full p-2 pr-10 border border-gray-300 rounded-md bg-[#ffffff] dark:bg-[#1D1D1F] dark:text-textDark cursor-pointer" />

                            <!-- Arrow icon -->
                            <i *ngIf="!isJobRoleOpen"
                                class="fa-solid fa-angle-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>

                            <i *ngIf="isJobRoleOpen"
                                class="fa-solid fa-angle-up absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                        </div>

                        <!-- Options -->
                        <div *ngIf="isJobRoleOpen"
                            class="absolute mt-1 w-full bg-white border dark:bg-[#292929] dark:text-textDark border-gray-200 dark:border-[#828282] rounded-md shadow-lg z-10">
                            <div *ngFor="let role of jobRoles" (click)="getJobRole(role)"
                                class="flex items-center px-4 py-2 dark:text-textDark cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-700 transition">
                                <span [ngClass]="{
      'text-blue-600 dark:text-blue-400 font-medium': role === personalData.jobRole,
      'text-gray-900 dark:text-textDark': role !== personalData.jobRole
    }">
                                    {{ role }}
                                </span>
                                <span *ngIf="role === personalData.jobRole" class="ml-2 text-blue-600">✓</span>
                            </div>
                        </div>

                        <div *ngIf="jobRoleInputTouched && !personalData.jobRole" class="text-red-500 text-sm mt-1">
                            Job Role is required
                        </div>
                    </div>

                    <div *ngIf="logingRole === 'Collection Centre Manager'"></div>


                    <div
                        *ngIf="logingRole === 'Collection Centre Head' && (personalData.jobRole === 'Collection Officer' || personalData.jobRole === 'Customer Officer')">
                        <label for="centerId" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                            Manager *
                        </label>


                        <div class="relative w-full">
                            <!-- Input acting as dropdown -->
                            <div class="relative">
                                <input type="text" id="irmId" name="irmId" [(ngModel)]="selectedManager"
                                    #irmIdInput="ngModel" required placeholder="-- Select a manager --" readonly
                                    (click)="toggleManagerDropdown()"
                                    class="form-control focus:outline-none focus:ring-0 focus:border-gray-300 mt-1 block w-full p-2 pr-10 border border-gray-300 rounded-md bg-[#ffffff] dark:bg-[#1D1D1F] dark:text-textDark cursor-pointer" />

                                <!-- Arrow icon -->
                                <i *ngIf="!managerDropdownOpen"
                                    class="fa-solid fa-angle-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>

                                <i *ngIf="managerDropdownOpen"
                                    class="fa-solid fa-angle-up absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 pointer-events-none"></i>
                            </div>

                            <!-- Dropdown panel -->
                            <div *ngIf="managerDropdownOpen"
                                class="absolute z-50 mt-1 w-full bg-white border dark:bg-[#292929] dark:text-textDark border-gray-200 dark:border-[#828282] max-h-60 overflow-y-auto shadow-lg">

                                <!-- Sticky search input -->
                                <div class="sticky top-0 bg-gray-100 dark:bg-[#292929] z-20">
                                    <div class="relative">
                                        <input type="text" placeholder="Search..."
                                            (input)="onManagerSearchInput($event)"
                                            class="dropdown-manager-search-input form-control dark:text-textDark dark:bg-[#292929] w-full p-2 pr-10 border-b border-gray-300 rounded-t-md" />
                                        <i
                                            class="fa-solid fa-magnifying-glass absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500"></i>
                                    </div>
                                </div>

                                <!-- List -->
                                <div *ngFor="let item of filteredManagerArr"
                                    class="flex items-center p-2 hover:bg-gray-200 dark:hover:bg-gray-700 dark:text-textDark cursor-pointer"
                                    (click)="selectManager(item)">
                                    <span [ngClass]="{
      'text-blue-600 dark:text-blue-400 font-medium': item.id === personalData.irmId,
      'text-gray-900 dark:text-textDark': item.id !== personalData.irmId
    }">

                                        {{ item.empId }} - {{ item.firstNameEnglish }} {{ item.lastNameEnglish }}

                                    </span>
                                    <span *ngIf="item.id === personalData.irmId" class="ml-2 text-blue-600">✓</span>
                                </div>
                                <div *ngIf="filteredManagerArr.length === 0"
                                    class="p-2 text-gray-500 dark:text-gray-400 bg-white dark:bg-[#292929] text-sm text-center">
                                    No options found
                                </div>
                            </div>
                        </div>

                        <div *ngIf="irmIdInput.touched && !personalData.irmId && logingRole === 'Collection Centre Head' && (personalData.jobRole === 'Collection Officer' || personalData.jobRole === 'Customer Officer')"
                            class="text-red-500 text-sm mt-1">
                            <div>Collection Centre Manager is required</div>
                        </div>
                    </div>

                    <!-- <div *ngIf="logingRole === 'Collection Centre Head'"></div> -->

                </div>


                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label for="languages" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                            Staff employee type *
                        </label>

                        <div class="flex items-center space-x-4 mt-3">
                            <div class="flex items-center space-x-2 ">
                                <input class="w-5 h-5 cursor-pointer" type="radio" id="sinhala" name="employeeType"
                                    value="Permanent" [(ngModel)]="personalData.employeeType"
                                    #employeeTypeInput="ngModel">
                                <label for="sinhala"
                                    class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Permanent</label>
                            </div>
                            <div class="flex items-center space-x-2 ">
                                <input class="w-5 h-5 cursor-pointer" type="radio" id="employeeTypetemp"
                                    name="employeeType" value="Temporary" [(ngModel)]="personalData.employeeType"
                                    #employeeTypeInput="ngModel">
                                <label for="employeeTypetemp"
                                    class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Temporary</label>
                            </div>
                        </div>

                        <div *ngIf="employeeTypeInput.touched && !personalData.employeeType"
                            class="text-red-500 text-sm mt-1">
                            <div>Employee Type is required</div>
                        </div>

                    </div>




                    <div>
                        <label for="languages" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                            Preferred Languages *
                        </label>
                        <div class="flex items-center space-x-4 mt-3">
                            <div class="flex items-center space-x-2 ">
                                <input class="w-5 h-5 cursor-pointer dark:bg-[gray]" type="checkbox" id="sinhala"
                                    name="languages" value="Sinhala" (change)="onCheckboxChange('Sinhala', $event)"
                                    [checked]="personalData.languages.includes('Sinhala')" />
                                <label for="sinhala" class="text-[#534E4E] dark:text-textDark">Sinhala</label>
                            </div>
                            <div class="flex items-center space-x-2 ">
                                <input class="w-5 h-5 cursor-pointer dark:bg-[gray]" type="checkbox" id="english"
                                    name="languages" value="English" (change)="onCheckboxChange('English', $event)"
                                    [checked]="personalData.languages.includes('English')" />
                                <label for="english" class="text-[#292929] dark:text-textDark">English</label>
                            </div>
                            <div class="flex items-center space-x-2 ">
                                <input class="w-5 h-5 cursor-pointer dark:bg-[gray]" type="checkbox" id="tamil"
                                    name="languages" value="Tamil" (change)="onCheckboxChange('Tamil', $event)"
                                    [checked]="personalData.languages.includes('Tamil')" />
                                <label for="tamil" class="text-[#292929] dark:text-textDark">Tamil</label>
                            </div>
                        </div>
                        <!-- Error Message -->
                        <p *ngIf="languagesRequired" class="text-red-500 text-sm mt-2">
                            Please select at least one Preferred Language.
                        </p>
                    </div>



                    <div>
                        <label for="firstNameEnglish"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark">First
                            Name (in English) *</label>
                        <input id="firstNameEnglish" [(ngModel)]="personalData.firstNameEnglish" name="firstNameEnglish"
                            class="form-control mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #firstNameEnglishInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'firstNameEnglish')" />
                        <div *ngIf="firstNameEnglishInput.touched && !personalData.firstNameEnglish"
                            class="text-red-500 text-sm mt-1">
                            <div>First Name (in English) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="lastNameEnglish"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Last
                            Name (in English) *</label>
                        <input id="lastNameEnglish" name="lastNameEnglish" [(ngModel)]="personalData.lastNameEnglish"
                            class="mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #lastNameEnglishInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'lastNameEnglish')" />
                        <div *ngIf="lastNameEnglishInput.touched && !personalData.lastNameEnglish"
                            class="text-red-500 text-sm mt-1">
                            <div>Last Name (in English) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="firstNameSinhala"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark">First
                            Name (in Sinhala) *</label>
                        <input id="firstNameSinhala" name="firstNameSinhala" [(ngModel)]="personalData.firstNameSinhala"
                            class="mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #firstNameSinhalaInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'firstNameSinhala')" />
                        <div *ngIf="firstNameSinhalaInput.touched && !personalData.firstNameSinhala"
                            class="text-red-500 text-sm mt-1">
                            <div>First Name (in Sinhala) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="lastNameSinhala"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Last
                            Name (in Sinhala) *</label>
                        <input id="lastNameSinhala" name="lastNameSinhala" [(ngModel)]="personalData.lastNameSinhala"
                            class="mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #lastNameSinhalaInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'lastNameSinhala')" />
                        <div *ngIf="lastNameSinhalaInput.touched && !personalData.lastNameSinhala"
                            class="text-red-500 text-sm mt-1">
                            <div>Last Name (in Sinhala) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="firstNameTamil"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark">First
                            Name (in Tamil) *</label>
                        <input id="firstNameTamil" name="firstNameTamil" [(ngModel)]="personalData.firstNameTamil"
                            class="mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #firstNameTamilInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'firstNameTamil')" />
                        <div *ngIf="firstNameTamilInput.touched && !personalData.firstNameTamil"
                            class="text-red-500 text-sm mt-1">
                            <div>First Name (in Tamil) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="lastNameTamil"
                            class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Last
                            Name (in Tamil) *</label>
                        <input id="lastNameTamil" name="lastNameTamil" [(ngModel)]="personalData.lastNameTamil"
                            class="mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                            #lastNameTamilInput="ngModel" required (keydown)="blockSpecialChars($event)"
                            (input)="onFormatInput($event, personalData, 'lastNameTamil')" />
                        <div *ngIf="lastNameTamilInput.touched && !personalData.lastNameTamil"
                            class="text-red-500 text-sm mt-1">
                            <div>Last Name (in Tamil) is required</div>
                        </div>
                    </div>

                    <div>
                        <label for="phoneNumber01" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                            Mobile Number - 1 *
                        </label>
                        <div class="mt-1 flex">
                            <div class="dropdown-wrapper-1 relative inline-block w-36 mr-2">
                                <!-- Selected item -->
                                <div class="flex items-center justify-between p-2 border border-gray-300 rounded-md bg-gray-50 dark:bg-[#1D1D1F] text-[#534E4E] dark:text-textDark cursor-pointer"
                                    (click)="dropdownOpen = !dropdownOpen">
                                    <div class="flex items-center gap-2">
                                        <img *ngIf="selectedCountry1" [src]="getFlagUrl(selectedCountry1.code)"
                                            width="24" height="18" alt="{{ selectedCountry1.name }}" />
                                        <span>{{ selectedCountry1?.dialCode }}</span>
                                    </div>
                                    <span *ngIf="!dropdownOpen"><i class="fa-solid fa-angle-down"></i></span>
                                    <span *ngIf="dropdownOpen"><i class="fa-solid fa-angle-up"></i></span>
                                </div>

                                <!-- Dropdown list -->
                                <div *ngIf="dropdownOpen"
                                    class="absolute left-0 mt-1 w-full border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] z-10 max-h-40 overflow-y-auto">
                                    <div *ngFor="let country of countries"
                                        class="flex items-center gap-2 p-2 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
                                        (click)="selectCountry1(country)">
                                        <img [src]="getFlagUrl(country.code)" width="24" height="18"
                                            alt="{{ country.name }}" />
                                        <span class="dark:text-white">{{ country.dialCode }}</span>
                                    </div>
                                </div>
                            </div>


                            <input id="phoneNumber01" name="phoneNumber01" type="tel"
                                [(ngModel)]="personalData.phoneNumber01"
                                class="block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-r-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                                placeholder="Enter your mobile number" #phoneNumber01Input="ngModel" required
                                (ngModelChange)="validateSriLankanPhone($event, 'phone01')" pattern="^[0-9]{9}$"
                                (keypress)="blockInvalidKeypressForPhone($event)" (input)="onPhoneInput($event)"
                                (paste)="blockInvalidPasteForPhone($event)" minlength="9" maxlength="9"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />
                        </div>
                        <div *ngIf="phoneNumber01Input.touched && !personalData.phoneNumber01"
                            class="text-red-500 text-sm mt-1">
                            <div> Mobile Number - 1 is required</div>
                        </div>
                        <div *ngIf="personalData.phoneNumber01 && phoneNumber01Input.invalid && !isPhoneInvalidMap['phone01']"
                            class="text-red-500 text-sm mt-1">
                            Mobile Number must be exactly 9 digits.
                        </div>

                        <div *ngIf="isPhoneInvalidMap['phone01'] && personalData.phoneNumber01"
                            class="text-red-500 text-sm mt-1">
                            Mobile Number must be exactly 9 digits.
                        </div>
                    </div>

                    <div>
                        <label for="phoNumTwo" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                            Mobile Number - 2
                        </label>
                        <div class="mt-1 flex">

                            <div class="dropdown-wrapper-2 relative inline-block w-36 mr-2">
                                <!-- Selected item -->
                                <div class="flex items-center justify-between p-2 border border-gray-300 rounded-md bg-gray-50 dark:bg-[#1D1D1F] text-[#534E4E] dark:text-textDark cursor-pointer"
                                    (click)="dropdownOpen2 = !dropdownOpen2">
                                    <div class="flex items-center gap-2">
                                        <img *ngIf="selectedCountry2" [src]="getFlagUrl(selectedCountry2.code)"
                                            width="24" height="18" alt="{{ selectedCountry2.name }}" />
                                        <span>{{ selectedCountry2?.dialCode }}</span>
                                    </div>
                                    <span *ngIf="!dropdownOpen2"><i class="fa-solid fa-angle-down"></i></span>
                                    <span *ngIf="dropdownOpen2"><i class="fa-solid fa-angle-up"></i></span>
                                </div>

                                <!-- Dropdown list -->
                                <div *ngIf="dropdownOpen2"
                                    class="absolute left-0 mt-1 w-full border border-gray-300 rounded-md bg-white dark:bg-[#1D1D1F] z-10 max-h-40 overflow-y-auto">
                                    <div *ngFor="let country of countries"
                                        class="flex items-center gap-2 p-2 hover:bg-gray-200 dark:hover:bg-gray-700 cursor-pointer"
                                        (click)="selectCountry2(country)">
                                        <img [src]="getFlagUrl(country.code)" width="24" height="18"
                                            alt="{{ country.name }}" />
                                        <span class="dark:text-white">{{ country.dialCode }}</span>
                                    </div>
                                </div>
                            </div>
                            <input id="phoneNumber02" name="phoneNumber02" type="tel" #phoneNumber02Input="ngModel"
                                [(ngModel)]="personalData.phoneNumber02"
                                class="block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-r-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                                placeholder="Enter your mobile number" pattern="^[0-9]{9}$" minlength="9" maxlength="9"
                                (ngModelChange)="validateSriLankanPhone($event, 'phone02')"
                                (keypress)="blockInvalidKeypressForPhone($event)" (input)="onPhoneInput($event)"
                                (paste)="blockInvalidPasteForPhone($event)"
                                (keypress)="($event.charCode >= 48 && $event.charCode <= 57) ? true : $event.preventDefault()" />

                        </div>
                        <div *ngIf="personalData.phoneNumber02 && phoneNumber02Input.invalid && !isPhoneInvalidMap['phone02']"
                            class="text-red-500 text-sm mt-1">
                            Mobile Number must be exactly 9 digits.
                        </div>

                        <div *ngIf="personalData.phoneNumber02 && personalData.phoneNumber02 === personalData.phoneNumber01 && !isPhoneInvalidMap['phone02'] && !phoneNumber02Input.invalid"
                            class="text-red-500 text-sm mt-1">
                            Mobile Number - 2 should be different from Mobile Number - 1.
                        </div>

                        <div *ngIf="isPhoneInvalidMap['phone02'] && personalData.phoneNumber02"
                            class="text-red-500 text-sm mt-1">
                            Mobile Number must be exactly 9 digits.
                        </div>
                    </div>

                    <div>
                        <label for="nic" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">NIC
                            Number *</label>
                        <input id="nic" name="nic" [(ngModel)]="personalData.nic" #nicInput="ngModel" required
                            maxlength="12" pattern="^(\d{9}[V]|\d{12})$" (input)="onNicInput($event)"
                            class="mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
                        <div *ngIf="nicInput.touched && !personalData.nic" class="text-red-500 text-sm mt-1">
                            <div> NIC is required</div>
                        </div>

                        <div *ngIf="nicInput.touched && nicInput.errors?.['pattern']" class="text-red-500 text-sm mt-1">
                            <div>Please enter a valid NIC number (12 digits or 10 digits followed by 'V').</div>
                        </div>
                    </div>

                    <div>
                        <label for="email" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Email
                            *</label>
                        <input type="email" id="email" name="email" [(ngModel)]="personalData.email"
                            #emailInput="ngModel" required
                            pattern="^[a-zA-Z0-9]+([._-][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([.-][a-zA-Z0-9]+)*\.[a-zA-Z]{2,}$"
                            (input)="onTrimInput($event, personalData, 'email')"
                            class="mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />

                        <div *ngIf="emailInput.touched && !personalData.email" class="text-red-500 text-sm mt-1">
                            Email is required
                        </div>

                        <div *ngIf="emailInput.touched && emailInput.errors?.['pattern']"
                            class="text-red-500 text-sm mt-1">
                            <!-- <p>Invalid email format (e.g., example&#64;mail.com)</p> -->
                            <p>Please enter a valid email in the format: example&#64;domain.com</p>
                        </div>
                    </div>
                </div>



                <div class="flex justify-end my-10 ml-10">
                    <button type="button"
                        class="px-6 py-2 bg-[#F6F7F9] border-gray-400 border-[2px] text-[#6B7D8C] rounded-lg mr-2"
                        (click)="onCancel()">Cancel</button>
                    <button (click)="
                    !PageOneForm.invalid 
                    && !this.languagesRequired
                    && personalData.phoneNumber02 !== personalData.phoneNumber01 
                    && personalData.languages !== ''
                    && personalData.jobRole 
                    && !isPhoneInvalidMap['phone01'] 
                    && ((personalData.phoneNumber02 && !isPhoneInvalidMap['phone02']) || !personalData.phoneNumber02)
                      ? nextForm('pageTwo') 
                      : nextForm('pageOne')
                  " type="submit" class="px-6 py-1 bg-[#415CFF] text-white rounded-lg">Next</button>
                </div>


            </div>
        </div>
    </form>

    <form #PageTwoForm="ngForm" (ngSubmit)="onSubmitForm2(PageTwoForm)">

        <div *ngIf="selectedPage === 'pageTwo'">

            <h2 class="text-xl mb-6 text-[#292929] dark:text-textDark font-semibold">Residential Details</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mb-4">
                <div>
                    <label for="house" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">House /
                        Plot Number *</label>
                    <input id="houseNumber" name="houseNumber" [(ngModel)]="personalData.houseNumber"
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #houseNumberInput="ngModel" required
                        (input)="onFormatInput2($event, personalData, 'houseNumber')" />
                    <div *ngIf="houseNumberInput.touched && !personalData.houseNumber"
                        class="text-red-500 text-sm mt-1">
                        <div>House / Plot Number is required</div>
                    </div>
                </div>

                <div>
                    <label for="street" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Street
                        Name *</label>
                    <input id="streetName" name="streetName" [(ngModel)]="personalData.streetName"
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #streetNameInput="ngModel" required
                        (input)="onFormatInput2($event, personalData, 'streetName')" />
                    <div *ngIf="streetNameInput.touched && !personalData.streetName" class="text-red-500 text-sm mt-1">
                        <div>Street Name is required</div>
                    </div>
                </div>

                <div>
                    <label for="city" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">City *</label>
                    <input id="city" name="city" [(ngModel)]="personalData.city"
                        (input)="onFormatInput2($event, personalData, 'city')"
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #cityInput="ngModel" required />
                    <div *ngIf="cityInput.touched && !personalData.city" class="text-red-500 text-sm mt-1">
                        <div>City is required</div>
                    </div>

                </div>

                <div>
                    <label for="district" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                        District *
                    </label>

                    <app-searchable-dropdown id="district" name="district" [items]="districtItems"
                        [placeholder]="'Select a district'" [searchPlaceholder]="'Search districts...'"
                        [(ngModel)]="personalData.district" #districtInput="ngModel"
                        (ngModelChange)="onDistrictChange($event)" borderClass="border border-gray-300"
                        placeholderClass="text-gray-400"></app-searchable-dropdown>

                    <div *ngIf="districtInput.touched && !personalData.district" class="text-red-500 text-sm mt-1">
                        <div>District is required</div>
                    </div>
                </div>

                <div>
                    <label for="province" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                        Province *
                    </label>
                    <input id="province" name="province" [(ngModel)]="personalData.province" #provinceInput="ngModel"
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        readonly />

                    <div *ngIf="provinceInput.touched && !personalData.province" class="text-red-500 text-sm mt-1">
                        <div>Province is required</div>
                    </div>
                </div>


                <div>
                    <label for="country" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Country
                        *</label>
                    <input id="country" name="country" [(ngModel)]="personalData.country" readonly
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]" />
                </div>




            </div>

            <div class="mt-24">
                <h2 class="text-xl mb-6 text-[#292929] dark:text-textDark font-semibold">Add Bank Details</h2>
                <div class="pb-6">
                    <label for="accHolderName"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Account
                        Holder’s Name *</label>
                    <input id="accHolderName" name="accHolderName" [(ngModel)]="personalData.accHolderName"
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #accHolderNameInput="ngModel" required (keydown)="blockSpecialChars($event)"
                        (input)="onFormatInput($event, personalData, 'accHolderName')" pattern="^[a-zA-Z0-9\s.']*$" />
                    <div *ngIf="accHolderNameInput.touched && !personalData.accHolderName"
                        class="text-red-500 text-sm mt-1">
                        <div>Account Holder's Name is required</div>
                    </div>
                    <div *ngIf="accHolderNameInput.touched && personalData.accHolderName && accHolderNameInput.invalid"
                        class="text-red-500 text-sm mt-1">
                        Please do not enter any special characters(eg., !, $, etc).
                    </div>
                </div>

                <div class="pb-6">
                    <label for="accNumber" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Account
                        Number *</label>
                    <input type="number" id="accNumber" name="accNumber" [(ngModel)]="personalData.accNumber"
                        (wheel)="$event.preventDefault()"
                        (keydown.arrowup)="$event.preventDefault()" (keydown.arrowdown)="$event.preventDefault()"
                        (input)="onTrimInputAccountNumber($event, personalData, 'accNumber')"
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #accNumberInput="ngModel" required pattern="^[a-zA-Z0-9]+$" />
                    <div *ngIf="accNumberInput.touched && !personalData.accNumber" class="text-red-500 text-sm mt-1">
                        <div>Account Number is required</div>
                    </div>

                    <div *ngIf="accNumberInput.touched && personalData.accNumber && accNumberInput.errors?.['pattern']"
                        class="text-red-500 text-sm mt-1">
                        <div>Account Number cannot contain special characters</div>
                    </div>
                </div>

                <div class="pb-6">
                    <label for="accNumber" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Confirm
                        Account Number *</label>
                    <input type="number" id="conformAccNumber" name="conformAccNumber"
                        (wheel)="$event.preventDefault()"
                        (keydown.arrowup)="$event.preventDefault()" (keydown.arrowdown)="$event.preventDefault()"
                        [(ngModel)]="personalData.conformAccNumber"
                        class="mt-1 block w-full p-2 border border-[#D9D9D9] hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #conformAccNumberInput="ngModel" required pattern="^[a-zA-Z0-9]+$"
                        (input)="onTrimInputAccountNumber($event, personalData, 'conformAccNumber')" />
                    <div *ngIf="conformAccNumberInput.touched && !personalData.conformAccNumber"
                        class="text-red-500 text-sm mt-1">
                        <div>Confirm Account Number is required</div>
                    </div>
                    <div *ngIf="personalData.conformAccNumber && personalData.accNumber !== personalData.conformAccNumber"
                        class="text-red-500 text-sm mt-1">
                        <div>Confirm Account Number should be the same as Account Number.</div>
                    </div>

                    <div *ngIf="conformAccNumberInput.touched && personalData.accNumber && conformAccNumberInput.errors?.['pattern']"
                        class="text-red-500 text-sm mt-1">
                        <div>Confirm Account Number cannot contain special characters</div>
                    </div>
                </div>

                <div class="pb-6">
                    <label for="bankDropdown" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                        Bank Name *
                    </label>

                    <app-searchable-dropdown id="bankDropdown" name="bankDropdown" [items]="bankItems"
                        [placeholder]="'Select a bank'" [searchPlaceholder]="'Search banks...'"
                        [(ngModel)]="selectedBankId" #selectedBank="ngModel" (ngModelChange)="onBankChange($event)"
                        borderClass="border border-gray-300" placeholderClass="text-gray-400">
                    </app-searchable-dropdown>

                    <div *ngIf="!selectedBankId && selectedBank.touched" class="text-red-500 text-sm mt-1">
                        <div>Bank Name is required</div>
                    </div>
                </div>

                <div class="pb-6">
                    <label for="branchDropdown" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">
                        Branch Name *
                    </label>

                    <app-searchable-dropdown id="branchDropdown" name="branchDropdown" [items]="branchItems"
                        [placeholder]="'Select a branch'" [searchPlaceholder]="'Search branches...'"
                        [(ngModel)]="selectedBranchId" #selectedBranch="ngModel"
                        (ngModelChange)="onBranchChange($event)" [disabled]="!selectedBankId"
                        borderClass="border border-gray-300" placeholderClass="text-gray-400">
                    </app-searchable-dropdown>

                    <div *ngIf="!selectedBranchId && selectedBranch.touched" class="text-red-500 text-sm mt-1">
                        <div>Branch Name is required</div>
                    </div>
                </div>
            </div>

            <div class="flex justify-end my-10 ml-10">
                <button (click)="nextForm('pageOne')" type="button"
                    class="px-6 py-2 bg-[#F6F7F9] border-[#95A1AC] border-[2px] text-[#6B7D8C] rounded-lg mr-2">
                    Back
                </button>

                <button *ngIf="personalData.jobRole !== jobRoleTypes.lightWeightDriver && personalData.jobRole !== jobRoleTypes.heavyWeightDriver" type="submit"
                    class="px-6 py-1 bg-[#415CFF] text-[#FFFFFF] rounded-lg" (click)="
                    !PageTwoForm.invalid 
                      ? onSubmit()
                      : nextForm('pageTwo')
                  ">
                    Sent to Approve
                </button>


                <button *ngIf="personalData.jobRole === jobRoleTypes.lightWeightDriver || personalData.jobRole === jobRoleTypes.heavyWeightDriver" type="submit"
                    class="px-6 py-1 bg-[#415CFF] text-[#FFFFFF] rounded-lg" (click)="
                    !PageTwoForm.invalid && selectedBankId && selectedBranchId && (personalData.accNumber === personalData.conformAccNumber)
                      ? nextForm('pageThree')
                      : nextForm('pageTwo')
                  ">
                    Next
                </button>
            </div>
        </div>
    </form>

    <form #PageThreeForm="ngForm" (ngSubmit)="onSubmitForm3(PageThreeForm)">

        <div *ngIf="selectedPage === 'pageThree'">

            <h2 class="text-xl mb-6 text-textLight dark:text-textDark font-semibold">Driving Details</h2>
            <div>
                <label for="licNo" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Driving
                    License ID</label>
                <input id="licNo" type="number" name="licNo" [(ngModel)]="driverObj.licNo"
                    class="form-licNo mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                    #licNoInput="ngModel" required />
                <div *ngIf="licNoInput.touched && !driverObj.licNo" class="text-red-500 text-sm mt-1">
                    <div>Driving License ID is required</div>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-11 my-5">
                <div>
                    <label for="licenseFrontImageUpload"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">
                        License's Front Image
                    </label>

                    <input id="licenseFrontImageUpload" type="file" accept="image/*"
                        (change)="onLicenseFrontImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'licenseFrontImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 cursor-pointer hover:bg-gray-200 transition-colors">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload License Front Image</p>
                    </div>

                    <div *ngIf="licenseFrontImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                licenseFrontImageFileName }}</span></span>
                        <button (click)="clearLicenseFrontImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>

                    <div *ngIf="isAppireImgValidation && !licenseFrontImageFileName" class="text-red-500 text-sm mt-1">
                        <div>License Front Image is required</div>
                    </div>
                </div>

                <div>
                    <label for="licenseBackImageUpload"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">License’s Back
                        Image</label>

                    <input id="licenseBackImageUpload" type="file" accept="image/*"
                        (change)="onLicenseBackImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'licenseBackImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 hover:bg-gray-200 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Back Image</p>
                    </div>
                    <div *ngIf="licenseBackImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                licenseBackImageFileName }}</span></span>
                        <button (click)="clearLicenseBackImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div *ngIf="isAppireImgValidation && !licenseBackImageFileName" class="text-red-500 text-sm mt-1">
                        <div>License Back Image is required</div>
                    </div>
                </div>
            </div>

            <h2 class="text-xl mt-16 mb-6 text-textLight dark:text-textDark font-semibold">Vehicle Insurance Details
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-11 my-5">
                <div>
                    <label for="insNo" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Insurance
                        Number</label>
                    <input id="insNo" type="number" name="insNo" [(ngModel)]="driverObj.insNo"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #insNoInput="ngModel" required />
                    <div *ngIf="insNoInput.touched && !driverObj.insNo" class="text-red-500 text-sm mt-1">
                        <div>Insurance Number is required</div>
                    </div>
                </div>

                <div class="">
                    <label for="insExpDate"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Insurance
                        Expire Date</label>
                    <input id="insExpDate" name="insExpDate" type="date" [(ngModel)]="driverObj.insExpDate"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        #insExpDateInput="ngModel" required />
                    <div *ngIf="insExpDateInput.touched && !driverObj.insExpDate" class="text-red-500 text-sm mt-1">
                        <div>Insurance Expire Date is required</div>
                    </div>
                </div>

                <div>
                    <label for="insurenceFrontImageUpload"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Insurance’s Front
                        Image</label>
                    <input id="insurenceFrontImageUpload" type="file" accept="image/*"
                        (change)="onInsurenceFrontImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'insurenceFrontImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 hover:bg-gray-200 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Front Image</p>
                    </div>
                    <div *ngIf="insurenceFrontImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                insurenceFrontImageFileName }}</span></span>
                        <button (click)="clearInsurenceFrontImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div *ngIf="isAppireImgValidation && !insurenceFrontImageFileName"
                        class="text-red-500 text-sm mt-1">
                        <div>Insurance’s Front Image is required</div>
                    </div>
                </div>

                <div>
                    <label for="firstNameEnglish"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Insurance’s Back
                        Image</label>
                    <input id="insuranceBackImageUpload" type="file" accept="image/*"
                        (change)="onInsurenceBackImageSelected($event)" class="hidden">


                    <div (click)="triggerFileInputForDriver($event, 'insuranceBackImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 hover:bg-gray-200 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Back Image</p>
                    </div>
                    <div *ngIf="insurenceBackImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                insurenceBackImageFileName }}</span></span>
                        <button (click)="clearInsurenceBackImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div *ngIf="isAppireImgValidation && !insurenceBackImageFileName" class="text-red-500 text-sm mt-1">
                        <div>Insurance’s Back Image is required</div>
                    </div>
                </div>
            </div>


            <h2 class="text-xl mt-16 mb-6 text-textLight dark:text-textDark font-semibold">Vehicle Details</h2>
            <div>
                <label for="vRegNo" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Vehicle
                    Registration Number</label>
                <input id="vRegNo" type="number" name="vRegNo" [(ngModel)]="driverObj.vRegNo" #vRegNoInput="ngModel"
                    required
                    class="form-control mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                    required />
                <div *ngIf="vRegNoInput.touched && !driverObj.vRegNo" class="text-red-500 text-sm mt-1">
                    <div>Vehicle Registration Number is required</div>
                </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-11 my-5">
                <div>
                    <label for="selectVehicletype"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Vehicle Type</label>
                    <select id="selectVehicletype" [(ngModel)]="selectVehicletype" name="selectVehicletype"
                        placeholder="select" (change)="vehicleChange()" required #selectVehicletypeInput="ngModel"
                        class="form-control mt-1 block w-full p-2 text-gray-700 dark:text-textDark border border-gray-300 hover:bg-gray-200  rounded-md bg-gray-100 dark:bg-[#1D1D1F] focus:ring-indigo-500 focus:border-indigo-500">
                        <option disabled selected
                            class="p-2 text-gray-700 dark:text-textDark bg-gray-100 dark:bg-[#1D1D1F]"
                            [value]="{name: '', capacity: ''}">
                            -- select Vehicle Type--
                        </option>
                        <option *ngFor="let item of VehicleTypes" [ngValue]="item"
                            class="p-2 text-gray-700 dark:text-textDark bg-gray-100 dark:bg-[#1D1D1F]">
                            {{item.name}}
                        </option>
                    </select>
                    <div *ngIf="selectVehicletypeInput.touched && !driverObj.vType" class="text-red-500 text-sm mt-1">
                        <div>Vehicle Type is required</div>
                    </div>
                </div>

                <div>
                    <label for="capacity" class="block text-sm font-medium text-[#534E4E] dark:text-textDark">Vehicle
                        Capacity</label>
                    <input id="capacity" placeholder="------------" [value]="selectVehicletype?.capacity"
                        class="form-control mt-1 block w-full p-2 border border-gray-300 hover:bg-gray-200 rounded-md text-textLight dark:text-textDark bg-tileLight dark:bg-[#1D1D1F]"
                        readonly />
                    <!-- <div *ngIf="firstNameEnglishInput.touched && !personalData.firstNameEnglish"
                        class="text-red-500 text-sm mt-1">
                        <div>First Name (in English) is required</div>
                    </div> -->
                </div>

                <div>
                    <label for="vehicleFrontImageUpload"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Front
                        Image</label>
                    <input id="vehicleFrontImageUpload" type="file" accept="image/*"
                        (change)="onVehicleFrontImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleFrontImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 hover:bg-gray-200 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Front Image</p>
                    </div>
                    <div *ngIf="vehicleFrontImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleFrontImageFileName }}</span></span>
                        <button (click)="clearVehicleFrontImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div *ngIf="isAppireImgValidation && !vehicleFrontImageFileName" class="text-red-500 text-sm mt-1">
                        <div>Vehicle’s Front Image is required</div>
                    </div>
                </div>

                <div>
                    <label for="vehicleBackImageUpload"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Back
                        Image</label>
                    <input id="vehicleBackImageUpload" type="file" accept="image/*"
                        (change)="onVehicleBackImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleBackImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 hover:bg-gray-200 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Back Image</p>
                    </div>
                    <div *ngIf="vehicleBackImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleBackImageFileName }}</span></span>
                        <button (click)="clearVehicleBackImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div *ngIf="isAppireImgValidation && !vehicleBackImageFileName" class="text-red-500 text-sm mt-1">
                        <div>Vehicle’s Back Image is required</div>
                    </div>
                </div>

                <div>
                    <label for="vehicleSideAImageUpload"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Side Image -
                        1</label>
                    <input id="vehicleSideAImageUpload" type="file" accept="image/*"
                        (change)="onVehicleSideAImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleSideAImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 hover:bg-gray-200 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Side Image - 1</p>
                    </div>
                    <div *ngIf="vehicleSideAImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleSideAImageFileName }}</span></span>
                        <button (click)="clearVehicleSideAImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div *ngIf="isAppireImgValidation && !vehicleSideAImageFileName" class="text-red-500 text-sm mt-1">
                        <div>Vehicle’s Side Image - 1 is required</div>
                    </div>
                </div>

                <div>
                    <label for="vehicleSideBImageUpload"
                        class="block text-sm font-medium text-[#534E4E] dark:text-textDark my-2">Vehicle’s Side Image -
                        2</label>
                    <input id="vehicleSideBImageUpload" type="file" accept="image/*"
                        (change)="onVehicleSideBImageSelected($event)" class="hidden">

                    <div (click)="triggerFileInputForDriver($event, 'vehicleSideBImageUpload')"
                        class="flex flex-row items-center justify-center bg-[#D2DADD] rounded-lg shadow-md gap-x-3 form-control mt-1 w-full p-2 border border-gray-300 hover:bg-gray-200 cursor-pointer">
                        <i class="fa-solid fa-upload text-[#534E4E] text-lg"></i>
                        <p>Upload Side Image - 2</p>
                    </div>
                    <div *ngIf="vehicleSideBImageFileName" class="mt-2 flex items-center gap-2">
                        <span class="text-sm font-semibold">Attached: <span class="text-[#415CFF] font-normal">{{
                                vehicleSideBImageFileName }}</span></span>
                        <button (click)="clearVehicleSideBImage()" class="text-red-500 hover:text-red-700 text-sm">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                    <div *ngIf="isAppireImgValidation && !vehicleSideBImageFileName" class="text-red-500 text-sm mt-1">
                        <div>Vehicle’s Side Image - 2 is required</div>
                    </div>
                </div>
            </div>



            <div class="flex justify-end my-10 ml-10">
                <button (click)="nextForm('pageTwo')" type="button"
                    class="px-6 py-2 bg-[#F6F7F9] border-gray-400 border-[2px] text-[#6B7D8C] rounded-lg mr-2">Back</button>
                <button type="submit" class="px-6 py-1 bg-[#415CFF] text-white rounded-lg"
                    (click)="!PageThreeForm.invalid ? onSubmit() : nextForm('pageThree')">Sent to
                    Approve</button>
                <!-- <button type="submit" class="px-4 py-2 bg-[#3980C0] text-white rounded-md" (click)="onSubmit()">Sent to
                        Approve</button> -->
            </div>
        </div>
    </form>


</div>
